import type { Resource } from '../../';
export const header_mobileMenu_membership: Resource = {"default":"Membership"};
